import i18n from "@/plugins/i18n";
export default {
  browse: {
    table: {
      headers: [
        {
          text: i18n.t("model.prop.no"),
          value: "index",
          sortable: false,
          filterable: false,
        },
        {
          text: "Plan",
          value: "Plan",
        },
        {
          text: "Coupon Key",
          value: "couponKey",
        },
      ],
    },
  },
  read: {
    tabs: [
      {
        key: "Info",
        label: i18n.t("string.info"),
      },
    ],
    table: {
      headers: [
        {
          text: "Plan",
          value: "Plan",
        },
        {
          text: "Coupon Key",
          value: "couponKey",
        },
        {
          text: i18n.t("model.prop.created"),
          value: "timestampCreated",
          filterable: false,
        },
        {
          text: i18n.t("model.prop.lastUpdated"),
          value: "timestampUpdated",
          filterable: false,
        },
      ],
    },
  },
  add: {
    fields: [
      {
        type: "model",
        key: "planKey",
        name: "Plan",
        model: "plan",
        optionText: "name",
        server: "sso",
        optionValue: "key",
      },
    ],
    rules: {
      planKey: [(v) => !!v || "Plan is required"],
    },
  },
  edit: false,
  delete: true,
};
